import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { axiosPrivate } from '../../api/axios';
import { secondsToHms } from '../../utils/time';
import arrow from '../../assets/arrow_right.png';
import dr15_2 from '../../assets/dr15_2.png';
 
interface Assessment {
  _id: string;
  title: string;
  thumbnail: string;
  duration: number;
}

const MainContent = () => {
  const [assessments, setAssessments] = useState<Assessment[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const itemsPerPage = 6;

  const user = JSON.parse(localStorage.getItem('user') as string);
  if (!user) {
    (window as Window).location = '/login';
  }
 
  useEffect(() => {
    fetchAssessments();
  }, [currentPage, searchQuery]);

  const fetchAssessments = async () => {
    try {
      const response = await axiosPrivate.get('/assessment/user', {
        params: {
          page: currentPage,
          limit: itemsPerPage,
          search: searchQuery,
          sortField: 'title',
          sortOrder: 'asc',
        },
      });

      setAssessments(response.data.assessments || []);
      setTotalPages(response.data.pagination.totalPages || 1);
    } catch (error) {
      console.error('Error fetching assessments:', error);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // reset to page 1 on search
  };

  const styles = {
    bottomBg: {
      position: 'fixed' as const,
      top: '10%',
      left: 0,
      bottom: 0,
      width: '100%',
      height: 'auto',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom center',
      backgroundImage: `url(${dr15_2})`,
      zIndex: -4,
    },
  };

  return (
    <section className="dasboard-content lg:w-[calc(100%-15rem)] bg-gray-sm min-h-[calc(100vh-104px)] sm:px-6 px-3 sm:py-7 py-4">
      <div className="w-full flex justify-start items-start mt-4 pb-6 mb-5">
        <div className="flex flex-col gap-2 w-full">
          <span className="font-bold text-[24px] text-[#141414]">Hello, User! 👋</span>
          <span className="font-medium text-[12px] text-[#989ca0]">Welcome back, track your team progress here!</span>
        </div>
      </div>

      {/* Search Box */}
      <div className="mb-4 w-full sm:w-1/2">
        <input
          type="text"
          placeholder="Search assessments..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
        />
      </div>

      <h3 className="md:text-2xl sm:text-xl text-base text-gray-black font-medium sm:mb-4 mb-2">
        New Assessments
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
        {assessments?.map((a: Assessment, idx: number) => (
          <div
            key={idx}
            className="bg-white p-4 rounded-xl border border-gray-300 drop-shadow-lg flex flex-col items-start justify-between min-h-[400px]"
            style={{ boxShadow: '0px 32px 26px rgba(0, 0, 0, 0.05)' }}
          >
            <div className="w-full h-40">
              <img className="w-full h-full object-cover rounded-t-xl" src={a.thumbnail} alt={a.title} />
            </div>
            <div className="w-full flex flex-col items-start px-4 py-3 flex-grow">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">{a.title}</h4>
              <span className="text-gray-600 text-sm">⏳ {secondsToHms(a.duration)}</span>
            </div>
            <Link
              to={`/assessment-overview/${a._id}`}
              className="flex items-center gap-2 px-4 py-2 border border-[#1e2a32] text-white bg-[#1e2a32] rounded-md hover:bg-[#14202a] transition"
            >
              <img src={arrow} alt="Arrow" style={{ height: '10px', width: '10px' }} />
              <span>Start Now</span>
            </Link>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="w-full flex justify-center items-center mt-6">
        <div className="flex items-center gap-2 px-4 py-2 bg-white">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`px-3 py-2 text-sm font-medium border rounded-md ${currentPage === page
                  ? 'bg-[#1e2a32] text-white border-[#1e2a32]'
                  : 'text-gray-700 hover:bg-gray-200 border-gray-400'
                }`}
            >
              {page}
            </button>
          ))}
        </div>
      </div>

      <div style={styles.bottomBg}></div>
    </section>
  );
};

export default MainContent;
